import type { AnchorHTMLAttributes, ReactNode, Ref } from "react";
import { forwardRef } from "react";

import CS from "metabase/css/core/index.css";
import { getUrlTarget } from "metabase/visualizations/lib/open-url";

import S from "./ExternalLink.module.css";
import { NewTabWarning, getNewTabTitle } from "./NewTabWarning";

interface Props extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href?: string;
  target?: string;
  className?: string;
  children?: ReactNode;
}

export const ExternalLink = forwardRef(function ExternalLink(
  {
    href,
    target = getUrlTarget(href),
    className,
    children,
    title,
    ...props
  }: Props,
  ref: Ref<HTMLAnchorElement>,
) {
  const opensInNewTab = target === "_blank";

  return (
    <a
      ref={ref}
      href={href}
      className={`${S.LinkRoot} ${className || CS.link}`}
      target={target}
      title={opensInNewTab ? getNewTabTitle(title) : title}
      // prevent malicious pages from navigating us away
      rel="noopener noreferrer"
      // disables quickfilter in tables
      onClickCapture={(e) => e.stopPropagation()}
      {...props}
    >
      {children}
      {opensInNewTab && <NewTabWarning />}
    </a>
  );
});

export const ButtonLink = forwardRef(function ButtonLink(
  props: Props,
  ref: Ref<HTMLAnchorElement>,
) {
  return <ExternalLink {...props} className={S.ButtonLink} ref={ref} />;
});
